module.exports = __webpack_public_path__ + "static/media/label.test.js.922007a4.snap";